import Modal from "@/components/modal"
import { t } from "i18next"
import Button from "@/components/button"
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons"

interface Props {
  onClose: () => void
}

export default function RiskSuccessModal({ onClose }: Props) {
  return (
    <Modal
      displayOwl
      displayOwlTop={100}
      isCloseButtonVisible
      onClose={onClose}
      className="max-w-2xl pt-0"
      disableOverflow
      footer={
        <Button className="primary" isWithBorder onClick={onClose} icon={faCheckCircle}>
          {t("Continuer")}
        </Button>
      }>
      <div className="flex flex-col gap-6 text-center">
        <div className="flex justify-center">
          <div className="text-6xl text-green-500">✓</div>
        </div>

        <div className="flex flex-col gap-3">
          <h2 className="text-xl font-semibold">{t("J'ai créé une fiche de risque pour vous")}</h2>
          <p className="text-gray-600 text-sm leading-relaxed w-[50%] mx-auto">
            {t(
              "Veuillez vérifier les champs ainsi que la cotation. N'hésitez pas à adapter les informations selon votre contexte."
            )}
          </p>
        </div>

        <div className="bg-gray-100 border border-gray-300 rounded-lg p-4 w-[50%] mx-auto">
          <p className="text-sm text-gray-700">
            {t("La fiche a déjà été enregistrée pour vous. Vous pouvez la modifier à n'importe quel moment.")}
          </p>
        </div>
      </div>
    </Modal>
  )
}
